import { ALLOWED_FILES_TYPES, MAX_FILE_SIZE } from "@/constants/files";
import type { MessageContentBlock, MessageContent } from "@/api/http/schemas/chatSessionSchemas";

const MESSAGE_SCHEMA_VERSION = "1.0.0";

export const getChatFileAcceptString = (): string => {
  return ALLOWED_FILES_TYPES.join(",");
};

export const isValidChatFileType = (file: File): boolean => {
  const extension = file.name.split(".").pop()?.toLowerCase();
  return extension ? ALLOWED_FILES_TYPES.includes(extension) : false;
};

export const isValidChatFileSize = (fileSize: number): boolean => {
  return fileSize <= MAX_FILE_SIZE;
};

export const createTextBlock = (text: string): MessageContentBlock => ({
  type: "text",
  text: text.trim(),
});

export const createFileBlock = (fileId: number, fileName: string): MessageContentBlock => ({
  type: "file",
  file_id: fileId,
  file_name: fileName,
});

export const buildMessageContent = (
  prompt: string,
  fileBlocks: MessageContentBlock[] = []
): MessageContent => {
  const contentBlocks: MessageContentBlock[] = [];

  if (prompt.trim()) {
    contentBlocks.push(createTextBlock(prompt));
  }

  contentBlocks.push(...fileBlocks);

  return {
    version: MESSAGE_SCHEMA_VERSION,
    content: contentBlocks,
  };
};
